import React from 'react';

import { useTranslation } from '@mint-lib/i18n';
import { Illustration } from '@mint-lib/illustrations';
import styled from '@mint-lib/styled';

import { Button, Typography } from '@myn/mui';

import { PanelTab } from '../PanelTab.js';

type Props = {
  setAddRowsPanel: (tab: PanelTab | null) => void;
};

const NoMediaRows: React.FC<Props> = ({ setAddRowsPanel }) => {
  const { t } = useTranslation('@myn/planning');

  return (
    <Wrapper>
      <Illustration
        className="h-36.25 w-37"
        component="IllustrationNoResults"
      />
      <Content>
        <Typography variant="h4">
          {t('There are not media rows yet')}
        </Typography>
        <SubTitle variant="bodyShort01">
          {t('Click on the button to start filling your buying plan')}
        </SubTitle>
      </Content>
      <Button size="large" onClick={() => setAddRowsPanel(PanelTab.AddRow)}>
        {t('Add row')}
      </Button>
    </Wrapper>
  );
};

export default NoMediaRows;

const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  border-radius: 4px;
  box-shadow:
    0px 1px 2px 0px rgba(0, 0, 0, 0.15),
    0px 0px 5px 0px rgba(23, 24, 24, 0.05);
  box-sizing: border-box;
  gap: ${({ theme }) => theme.spacing(2)};
`;

const Content = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
`;

const SubTitle = styled(Typography)`
  color: ${({ theme }) => theme.palette.text.secondary};
`;
